module.exports = __webpack_public_path__ + "img/LOGOS-100x100.adaf8997.png";